import { FrontOfficeAuthorizations } from 'shell/authorizations/front-office';

export const authsObj = Object.freeze({
  read: [FrontOfficeAuthorizations.TipoRilascioQuery],
  create: [FrontOfficeAuthorizations.TipoRilascioAdd],
  edit: [FrontOfficeAuthorizations.TipoRilascioUpdate],
  delete: [FrontOfficeAuthorizations.TipoRilascioDelete],
});
